document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-buy-now').forEach((button) => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();

      let variantId;
      let quantity = 1;

      // CASE 1: Product form exists
      const productForm = button.closest('form');

      if (productForm) {
        const variantSelect = productForm.querySelector('[name="id"]');
        const quantityField = productForm.querySelector('[name="quantity"]');

        variantId = variantSelect?.value;
        quantity = parseInt(quantityField?.value || 1);
      }

      // CASE 2: Standalone button
      if (!variantId) {
        variantId = button.dataset.variantId;
      }

      if (!variantId) {
        console.error('No variant ID found');
        return;
      }

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity,
              },
            ],
          }),
        });

        window.location.href = '/checkout';
      } catch (error) {
        console.error('Buy now error:', error);
      }
    });
  });
});